import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const usePostExternalIntegrationFieldMappingsMutation = ({
	onError,
	onSuccess,
	impersonationContext,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			integrationProvider,
			fieldMappings,
		}: {
			integrationProvider: Api.IntegrationProvider;
			fieldMappings: Api.IIntegrationFieldMapping[];
		}) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `integrations/${integrationProvider}/fieldMappings`,
				}),
				'POST',
				fieldMappings
			);
		},
		onError,
		onSuccess,
	});
};
